import React, { createContext, useContext, useState } from 'react';

const InviteTeamMemberContext = createContext();

export const InviteTeamMemberProvider = ({ children }) => {
  const [errors, setErrors] = useState([]); // null means no errors
  const [loading, setLoading] = useState(false);



  return (
    <InviteTeamMemberContext.Provider
      value={{
        errors,
        setErrors,
        loading,
        setLoading
      }}
    >
      {children}
    </InviteTeamMemberContext.Provider>
  );
};

export const useInviteTeamMember = () => {
  const context = useContext(InviteTeamMemberContext);
  if (!context) {
    throw new Error("useInviteTeamMember must be used within an InviteTeamMemberProvider");
  }
  return context;
};
